import { Conversation } from './types/Conversation';
import { MakeCall } from './createMakeCall';

const chargeTenant = (makeCall: MakeCall) => (conversationId: number) =>
  makeCall<Conversation>(
    'PUT',
    `/api/v2/conversation/${conversationId}/charge-tenant`,
  );
export { chargeTenant };
